import { useShowHide, useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { getSessionStorage } from '@helpers';
import { modals } from '@modals';
import { ROUTES, useNavigation } from '@navigation';
import { useIsOperator, useNavigationStep, useNavigationStore } from '@store';
import { useCallback, useMemo } from 'react';

interface DoubtsAndExitOutput {
	resources: DoubtsAndExitResources;
	onHandleLink: () => void;
	onHandleLinkExit: () => void;
}

interface DoubtsAndExitResources {
	hasDoubtsAndTalkWithUs: string;
	exit: string;
	navigateMbcp: string;
	navigateIzibizi: string;
}

export const useDoubtsAndExit = (): DoubtsAndExitOutput => {
	const t = useTranslation();
	const { navigate, navigateCustomUrl } = useNavigation();
	const { flow } = useNavigationStore();
	const { show } = useShowHide(modals.exitModule);
	const { current: currentRoute } = useNavigationStep();
	const isOperator = useIsOperator();

	const resources = useMemo((): DoubtsAndExitResources => {
		return {
			hasDoubtsAndTalkWithUs: t('general.hasDoubtsAndTalkWithUs'),
			exit: t('general.exit'),
			navigateMbcp: t('general.exit.navigateMbcp'),
			navigateIzibizi: t('general.exit.navigateIzibizi'),
		};
	}, [t]);

	const onHandleLink = () => {
		navigate('requestContact');
	};

	const onHandleLinkExit = useCallback(() => {
		if (flow === 'subscription') {
			if (currentRoute === ROUTES.subscriptionConclusion || isOperator) {
				const sessionStorage = getSessionStorage('ott');
				if (sessionStorage !== undefined) {
					navigateCustomUrl(resources.navigateMbcp);
				} else {
					navigateCustomUrl(resources.navigateIzibizi);
				}
			} else {
				show();
			}
		} else {
			navigate('subscriptionSelectPlan');
		}
	}, [
		currentRoute,
		flow,
		isOperator,
		resources.navigateIzibizi,
		resources.navigateMbcp,
		navigate,
		navigateCustomUrl,
		show,
	]);

	return {
		resources,
		onHandleLink,
		onHandleLinkExit,
	};
};
